import React from "react";
import { Card, Col, Row } from "antd";
import { StudyTypeOptions } from "../../constants";

type StudyTypesProps = {
    value?: string[];
    onChange?: (value: string[]) => void;
};

function chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunkedArray = [];

    for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        chunkedArray.push(chunk);
    }
    return chunkedArray;
}

export default function StudyTypes(props: StudyTypesProps) {
    const { value, onChange } = props;
    const selectedStudies = value || [];

    const ROW_LENGTH = 2;
    const grid = chunkArray(StudyTypeOptions, ROW_LENGTH);

    return (
        <div className="study-types">
            {grid.map((row, index) => (
                <Row style={{ marginTop: 16 }} gutter={[16, 16]} key={index}>
                    {row.map((col) => {
                        const inputId = `study-type-${col.id}`;
                        const isSelected = selectedStudies.includes(col.value);

                        return (
                            <Col sm={24} md={Math.floor(24 / row.length)} key={col.id}>
                                <label className="study-type-card-label" htmlFor={inputId}>
                                    <Card
                                        hoverable
                                        variant="outlined"
                                        className={`study-type-card responsive-card ${isSelected ? "item-selected" : ""}`}
                                    >
                                        <input
                                            className="study-type-checkbox-input"
                                            type="checkbox"
                                            id={inputId}
                                            name="study-types"
                                            value={col.value}
                                            checked={isSelected}
                                            onChange={(event) => {
                                                const nextSelection = event.target.checked
                                                    ? [...selectedStudies, col.value]
                                                    : selectedStudies.filter((studyId) => studyId !== col.value);
                                                onChange?.(nextSelection);
                                            }}
                                        />
                                        <div className="study-type-card-contents">
                                            {col.image}
                                            <div className="study-type-text">
                                                <div className="type-text-header">{col.label}</div>
                                                <div className="type-text-sub-header">{col.subLabel}</div>
                                                <div className="type-text-example">{col.example}</div>
                                            </div>
                                        </div>
                                        <div className="top-line" />
                                    </Card>
                                </label>
                            </Col>
                        );
                    })}
                </Row>
            ))}
        </div>
    );
}
